import * as React from "react";
const SvgUkg = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Ukg_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#E5FF22",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005151",
  d: "m21.963 9.055-1.092 1.029c-.155-.098-.345-.241-.554-.347-.753-.385-1.525-.42-2.296-.06-.507.238-.838.65-1.015 1.177-.238.71-.242 1.426.056 2.12.335.777.942 1.202 1.776 1.301.486.058.956-.024 1.418-.176.075-.024.082-.066.082-.13v-2.097h1.652q.006.06.008.123-.001 1.47.002 2.941c0 .086-.026.136-.1.18-.408.24-.852.382-1.31.49-.56.134-1.125.221-1.704.212a3.704 3.704 0 0 1-3.606-3.023c-.201-1.029-.107-2.025.398-2.955.573-1.055 1.474-1.669 2.644-1.868.995-.17 1.952-.03 2.844.47.29.162.551.362.799.614zM1.996 8.05h1.658v4.356c0 .333.03.662.158.976.219.534.63.81 1.186.89.32.047.637.027.944-.08.537-.19.83-.593.938-1.138.041-.212.054-.432.055-.648.005-1.4.002-2.8.002-4.199v-.153h1.648c.004.025.012.051.012.077-.001 1.502.01 3.004-.009 4.506-.01.922-.346 1.72-1.033 2.35-.546.5-1.202.757-1.933.818-.791.067-1.539-.085-2.207-.53-.85-.566-1.288-1.384-1.395-2.39a6 6 0 0 1-.023-.592V8.049M9.781 8.05h1.65v2.264c.055-.052.084-.08.113-.11q1.037-1.038 2.07-2.08a.25.25 0 0 1 .196-.083c.63.003 1.26.001 1.89.002.038 0 .075.004.13.006-.033.038-.051.063-.073.084-1.054 1.06-2.107 2.123-3.166 3.179-.685.682-1.73.664-2.382-.032a1.58 1.58 0 0 1-.433-1.098c-.006-.692-.002-1.384-.002-2.076 0-.015.004-.03.008-.056"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005151",
  d: "M15.808 15.68h-.114c-.63 0-1.26-.002-1.89.002a.25.25 0 0 1-.194-.083q-1.03-1.038-2.062-2.072l-.11-.106v2.25H9.78q-.005-.052-.007-.103c0-.656-.003-1.312 0-1.968.006-.856.549-1.514 1.378-1.66.503-.088.951.044 1.338.38q.08.07.154.146l3.082 3.094c.03.031.067.055.1.082q-.008.019-.018.038z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Ukg_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgUkg;
//# sourceMappingURL=Ukg.js.map